module.exports = ".SampleResults{\r\n    background-color: rgb(236, 236, 236);\r\n}\r\n\r\n\r\n.TableHeader{\r\n    background-color: rgb(255, 255, 255);\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/history/history.component.css
// module id = ./src/app/history/history.component.css
// module chunks = main